<template>
  <v-card class="" elevation="0" :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
    <v-row class="no-gutters align-center">
      <v-col cols="12" sm="12" md="4" lg="3">
        <v-text-field v-model="search" @input="debounceSearch" prepend-icon="mdi-magnify" label="Search here ..."
          single-line solo hide-details />
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="2">
        <v-select solo :items="allMethods()" v-model="methodName" @input="methodFilter" append-icon="mdi-chevron-down"
          label="Payment methods" class="custom-select" item-text="method_name" item-value="pretty_name" />
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="2">
        <v-select solo :items="slots" append-icon="mdi-chevron-down" label="All Status" class="custom-select"
          v-model="selectedStatus" @change="onStatusChange" />
      </v-col>

      <v-col cols="12" sm="6" md="6" lg="3">
        <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" width="290px" class="">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="selectedDatesText" placeholder="Date filter" prepend-icon="mdi-calendar"
              append-icon="mdi-chevron-down" readonly v-bind="attrs" v-on="on" solo class="custom-select" />
          </template>

          <v-date-picker v-model="selectedDates" class="custom-date-picker" scrollable range>
            <v-spacer></v-spacer>
            <v-btn :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'" text @click="cancelSelection">
              Cancel
            </v-btn>
            <v-btn :color="$vuetify.theme.dark ? '#fff' : '#131c29'" text @click="confirmSelection">
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>

      <v-col cols="12" sm="6" md="6" lg="2">
        <ul>
          <li class="mr-3 mr-lg-0">
            <span class="text--red">Withdraw:</span>
            <span class="text-right">${{ formattedAllNumber(totalWithdrawal) }}</span>
          </li>
          <li class="mr-3 mr-lg-0">
            <span>Total Count:</span>
            <span class="text-right">{{ formattedAllNumber(totalWithdrawalCount) }}</span>
          </li>
        </ul>
      </v-col>
    </v-row>
    <v-col cols="12" sm="4" md="4" lg="1" v-if="$canRoute('transaction-history') === 1" align="middle">
  <v-btn
    @click.prevent="downloadCSVexcel"
    :loading="excelLoading"
    :disabled="excelLoading"
    tile
    elevation="0"
    class="mt-6 text-capitalize btn-account mb-0 mx-0"
    color="greenMain"
  >
    <v-icon small>mdi mdi-tray-arrow-down</v-icon>Excel
  </v-btn>
</v-col>

    <v-row>
      <v-col cols="12" sm="12">
        <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-sheet class="transactionTable depositTabTable depositTableForTransaction"
            :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
            <v-data-table :headers="headers" :items="withdrawal" :server-items-length="pagination?.total || 10"
              :options.sync="options" :loading="isLoading" :items-per-page="options.itemsPerPage" :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': 'Rows per page:'
              }" @update:options="handleOptionsChange" disable-sort>
              <template v-slot:loading>
                <div class="d-flex align-center justify-center pa-4">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <span class="ml-2">Loading data...</span>
                </div>
              </template>

              <template v-slot:no-data>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-information</v-icon>
                  <span class="ml-2">No data found</span>
                </div>
              </template>

              <template v-slot:no-results>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-magnify</v-icon>
                  <span class="ml-2">No matching data found</span>
                </div>
              </template>

              <template v-slot:item.account_fullname="{ item }" v-if="$canRoute('registered-user?tab=1') === 1">
                <router-link class="text-capitalize text--ash"
                  :to="`/registered-user-details/${item?.client_account_id}`">
                  {{ `${item.account_fullname} (${item?.client_account_id})` }}
                </router-link>
              </template>

              <template v-slot:item.account_fullname="{ item }" v-else>
                <span class="text-capitalize text--ash">
                  {{ `${item.account_fullname} (${item?.client_account_id})` }}
                </span>
              </template>

              <template v-slot:item.reference="{ item }">
                {{ item?.reference || "N/A" }}
              </template>

              <template v-slot:item.trx_type="{ item }">
                <div class="d-flex align-items-center">
                  <v-icon color="#B4C2D1" small :class="verifyIcon(item.trx_type)"></v-icon>
                  <span>{{ item.trx_type }}</span>
                </div>
              </template>

              <template v-slot:item.admin_name="{ item }">
                {{ item?.admin_name || "N/A" }}
              </template>

              <template v-slot:item.trading_account_no="{ item }">
                {{ item?.trading_account_no }}
              </template>

              <template v-slot:item.account_email="{ item }">
                <v-tooltip top color="#000">
                  <template v-slot:activator="{ on }">
                    <v-btn plain title x-small v-on="on" @click="copyText(item)" style="text-transform: none">
                      {{ obfuscateAnyEmail(item?.account_email) }}
                      <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">
                        {{ copiedStates[item.id] ? "mdi mdi-check" : "mdi-content-copy" }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ item?.account_email }}</span>
                </v-tooltip>
              </template>

              <template v-slot:item.created_at="{ item }">
                {{ formatMySQLDate(item?.created_at) }}
              </template>

              <template v-slot:item.payment_system="{ item }">
                {{ item?.payment_system?.method_name || "N/A" }}
              </template>

              <template v-slot:item.status="{ item }">
                <div class="status-selection">
                  <v-select solo :items="updateslots"
                    :append-icon="item.status === 1 ? 'mdi-checkbox-marked-circle' : item.status === 2 ? 'mdi-cancel' : 'mdi-chevron-down'"
                    class="custom-select" v-model="item.status" item-text="statusText" item-value="status"
                    :disabled="isUpdating || item.status > 0 || $canRoute('withdraw') !== 1"
                    @change="onUpdateChange(item)">
                    <template v-slot:selection="{ item }">
                      <div :class="getTextColor(item)">
                        {{
                          item.status === 0
                            ? "Pending"
                            : item.status === 1
                              ? "Approved"
                              : item.status === 2
                                ? "Rejected"
                                : null
                        }}
                      </div>
                    </template>
                  </v-select>
                </div>
              </template>

              <template v-slot:item.details="{ item }">
                <v-dialog transition="scale-transition" origin="center center" max-width="985px"
                  v-model="detailsDialog[item?.id]" content-class="deposit-modal">
                  <template v-slot:activator="{ on, attrs }">
                    <div class="d-flex align-items-center">
                      <div v-bind="attrs" v-on="on">
                        <!-- IMPORTANT: pass full item so QR can generate -->
                        <v-icon color="#039de9" small @click="handleFile(item)">
                          mdi-eye-outline
                        </v-icon>
                      </div>
                    </div>
                  </template>

                  <template>
                    <v-card :color="$vuetify.theme.dark ? '#162334' : '#e8f1f8'" class="deposit-form">
                      <v-btn class="close-btn" icon dark @click="handleClose(item)">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>

                      <v-card-title>
                        <div class="image-details">
                          <v-img width="110" v-if="item?.payment_system?.method_name == 'Bank Transfer'"
                            src="@/assets/payments/bank.png"></v-img>
                          <v-img width="120" v-else-if="item?.payment_system?.method_name == 'Crypto'"
                            src="@/assets/payments/crypto.png"></v-img>
                          <v-img width="120" v-else-if="item?.payment_system?.method_name == 'Google Pay'"
                            src="@/assets/payments/gPay.png"></v-img>
                          <v-img width="120" v-else src="@/assets/payments/cash.png"></v-img>
                          <h3>{{ item?.payment_system?.method_name }}</h3>
                        </div>

                        <div class="content-details">
                          <h3>Withdrawal:</h3>
                          <span>${{ item?.amount }}</span>
                        </div>
                      </v-card-title>

                      <div v-if="selectedFile">
                        <div class="img-center" v-if="isImage(item?.payment_slip)">
                          <img :src="item.payment_slip" class="modal-img" />
                        </div>

                        <div v-else-if="isPDF(item?.payment_slip)">
                          <iframe :src="item.payment_slip" width="100%" class="modal-iframe" height="250px"
                            frameborder="0"></iframe>
                        </div>

                        <div v-else>
                          <p class="text-center">Unsupported file format.</p>
                        </div>
                      </div>

                      <div v-else>
                        <p class="text-center">No document preview available.</p>
                      </div>

                      <v-card-subtitle v-if="selectedFile">
                        <div class="download-icon cursor-pointer" @click="downloadFile(item?.payment_slip)">
                          <p>Download</p>
                          <v-icon small slot="append" color="#039de9">mdi-tray-arrow-down</v-icon>
                        </div>
                        <div class="tab-details cursor-pointer" @click="openInNewTab(item?.payment_slip)">
                          <p>Open In New Tab</p>
                          <v-icon small slot="append" color="#039de9">mdi-eye</v-icon>
                        </div>
                      </v-card-subtitle>

                      <v-card-text>
                        <v-row>
                          <v-col cols="12">
                            <h1>All Information</h1>
                          </v-col>

                          <v-col cols="12" sm="12" md="6">
                            <fieldset>
                              <legend>Name</legend>
                              <v-text-field :value="item?.account_fullname" readonly single-line solo hide-details
                                class="custom-select" />
                            </fieldset>
                          </v-col>

                          <v-col cols="12" sm="12" md="6">
                            <fieldset>
                              <legend>Email</legend>
                              <v-text-field readonly :value="item?.account_email" single-line solo hide-details
                                class="custom-select" />
                            </fieldset>
                          </v-col>

                          <v-col cols="12" sm="12" md="6">
                            <fieldset>
                              <legend>Account No</legend>
                              <v-text-field readonly :value="item?.trading_account_no" single-line solo hide-details
                                class="custom-select" />
                            </fieldset>
                          </v-col>

                          <v-col cols="12" sm="12" md="6">
                            <fieldset>
                              <legend>Transaction Method</legend>
                              <v-text-field readonly :value="item?.payment_system?.method_name" single-line solo
                                hide-details class="custom-select" />
                            </fieldset>
                          </v-col>

                          <v-col cols="12" sm="12" md="6">
                            <fieldset>
                              <legend>Transaction ID</legend>
                              <v-text-field readonly :value="item?.transaction_id || 'N/A'" single-line solo
                                hide-details class="custom-select" />
                            </fieldset>
                          </v-col>

                          <v-col cols="12" sm="12" md="6">
                            <fieldset>
                              <legend>Amount</legend>
                              <v-text-field readonly :value="item?.amount" single-line solo hide-details
                                class="custom-select" />
                            </fieldset>
                          </v-col>

                          <v-col cols="12" sm="12" md="6">
                            <fieldset>
                              <legend>Trx. Fee</legend>
                              <v-text-field readonly :value="item?.trx_fee" single-line solo hide-details
                                class="custom-select" />
                            </fieldset>
                          </v-col>

                          <v-col cols="12" sm="12" md="6">
                            <fieldset>
                              <legend>Net Amount</legend>
                              <v-text-field readonly :value="item?.net_amount" single-line solo hide-details
                                class="custom-select" />
                            </fieldset>
                          </v-col>

                          <v-col cols="12" sm="12" md="6">
                            <fieldset>
                              <legend>Reference No.</legend>
                              <v-text-field readonly :value="item?.reference" single-line solo hide-details
                                class="custom-select" />
                            </fieldset>
                          </v-col>

                          <v-col cols="12" sm="12" md="6">
                            <fieldset>
                              <legend>Time</legend>
                              <v-text-field readonly :value="item?.created_at" single-line solo hide-details
                                class="custom-select" />
                            </fieldset>
                          </v-col>

                          <v-col v-if="item?.bank_name" cols="12" sm="12" md="6">
                            <fieldset>
                              <legend>Bank name</legend>
                              <v-text-field readonly :value="item?.bank_name" single-line solo hide-details
                                class="custom-select" />
                            </fieldset>
                          </v-col>

                          <v-col v-if="item?.bank_account_no" cols="12" sm="12" md="6">
                            <fieldset>
                              <legend>Bank Account No.</legend>
                              <v-text-field readonly :value="item?.bank_account_no" single-line solo hide-details
                                class="custom-select" />
                            </fieldset>
                          </v-col>

                          <v-col v-if="item?.bank_iban" cols="12" sm="12" md="6">
                            <fieldset>
                              <legend>Bank IBAN</legend>
                              <v-text-field readonly :value="item?.bank_iban" single-line solo hide-details
                                class="custom-select" />
                            </fieldset>
                          </v-col>

                          <v-col v-if="item?.bank_swift_code" cols="12" sm="12" md="6">
                            <fieldset>
                              <legend>Bank Swift Code</legend>
                              <v-text-field readonly :value="item?.bank_swift_code" single-line solo hide-details
                                class="custom-select" />
                            </fieldset>
                          </v-col>

                          <v-col v-if="item?.ifsc_code" cols="12" sm="12" md="6">
                            <fieldset>
                              <legend>IFSC Code</legend>
                              <v-text-field readonly :value="item?.ifsc_code" single-line solo hide-details
                                class="custom-select" />
                            </fieldset>
                          </v-col>

                          <v-col v-if="item?.network" cols="12" sm="12" md="6">
                            <fieldset>
                              <legend>Network</legend>
                              <v-text-field readonly :value="item?.network" single-line solo hide-details
                                class="custom-select" />
                            </fieldset>
                          </v-col>

                          <!-- Wallet Address (UPDATED: copy icon) -->
                          <v-col v-if="item?.wallet_address" cols="12" sm="12" md="6">
                            <fieldset>
                              <legend>Crypto Address</legend>
                              <v-text-field readonly :value="item?.wallet_address" single-line solo hide-details
                                class="custom-select">
                                <v-icon small slot="append" class="cursor-pointer"
                                  :color="walletCopied[item.id] ? 'green' : '#039de9'"
                                  @click.stop="copyWalletAddress(item)"
                                  :title="walletCopied[item.id] ? 'Copied' : 'Copy address'">
                                  {{ walletCopied[item.id] ? 'mdi-check' : 'mdi-content-copy' }}
                                </v-icon>
                              </v-text-field>
                            </fieldset>
                          </v-col>

                          <!-- Wallet QR (NEW) -->
                          <v-col v-if="shouldShowWalletQr(item)" cols="12" class="d-flex justify-center">
                            <fieldset class="qr-fieldset">
                              <legend>Wallet QR</legend>

                              <div class="qr-wrap">
                                <v-progress-circular v-if="qrLoading[item.id]" indeterminate size="28" width="2"
                                  color="primary" />
                                <v-img v-else-if="walletQr[item.id]" :src="walletQr[item.id]" width="180" height="180"
                                  contain class="qr-img" />
                                <div v-else class="text-caption text--ash text-center">
                                  QR not available
                                </div>
                              </div>

                              <div class="d-flex justify-center mt-3">
                                <v-btn small text class="text-capitalize" color="#039de9"
                                  @click="copyWalletAddress(item)">
                                  <v-icon small class="mr-1" :color="walletCopied[item.id] ? 'green' : '#039de9'">
                                    {{ walletCopied[item.id] ? 'mdi-check' : 'mdi-content-copy' }}
                                  </v-icon>
                                  {{ walletCopied[item.id] ? 'Copied' : 'Copy Address' }}
                                </v-btn>
                              </div>
                            </fieldset>
                          </v-col>

                          <v-col cols="12" sm="12" md="6">
                            <fieldset>
                              <legend>Verification Image</legend>
                              <v-text-field readonly :value="item?.payment_slip" single-line solo hide-details
                                class="custom-select">
                                <v-icon small slot="append" color="#039de9" @click="downloadFile(item?.payment_slip)">
                                  mdi-tray-arrow-down
                                </v-icon>
                              </v-text-field>
                            </fieldset>
                          </v-col>

                          <v-col cols="12" sm="12" md="6">
                            <fieldset>
                              <legend>Status</legend>
                              <v-text-field readonly
                                :value="item?.status === 0 ? 'Pending' : item?.status === 1 ? 'Approved' : 'Rejected'"
                                single-line solo hide-details class="custom-select">
                                <v-icon small slot="prepend" color="#FFC020">mdi-star-outline</v-icon>
                              </v-text-field>
                            </fieldset>
                          </v-col>

                          <v-col cols="12" sm="12"
                            :md="item?.payment_system?.method_name == 'Cash Transfer' || item?.payment_system?.method_name != 'Bank Transfer' ? 12 : 6">
                            <fieldset>
                              <legend>Remarks</legend>
                              <v-text-field readonly :value="item?.remarks || 'N/A'" single-line solo hide-details
                                class="custom-select" />
                            </fieldset>
                          </v-col>
                        </v-row>

                        <v-row v-if="item?.status === 0">
                          <v-col cols="12">
                            <h3 class="text-success">Upload A Pay Slip</h3>
                          </v-col>
                          <v-col cols="12">
                            <fieldset>
                              <legend>Proof</legend>
                              <v-file-input v-model="pay_slip" label="Choose file in needed (Max Size 2MB)" single-line
                                solo prepend-icon="mdi-file-image" class="custom-select" @change="onFileChange" />
                            </fieldset>
                            <v-img v-if="previewUrl" class="img-logo-bank" :src="previewUrl" />
                            <span v-if="errors.pay_slip" class="error-message">{{ errors.pay_slip }}</span>
                          </v-col>
                        </v-row>

                        <v-row v-if="isItOpen(item) && $canRoute('withdraw') === 1">
                          <v-col cols="6">
                            <div class="button-wrapper">
                              <v-btn small tile elevation="0" block class="ma-0 text-capitalize btn-account py-4"
                                color="greenMain" :loading="isApproving" :disabled="isApproving || item?.status === 1"
                                @click="handleWithdrawApprove(item)">
                                <v-progress-circular v-if="isApproving" indeterminate size="16" width="2" color="white"
                                  class="mr-2" />
                                {{ item?.status === 1 ? "Approved" : (isApproving ? "Approving..." : "Approve") }}
                              </v-btn>
                            </div>
                          </v-col>

                          <v-col cols="6">
                            <div class="button-wrapper">
                              <v-btn small tile elevation="0" block class="ma-0 text-capitalize btn-account py-4"
                                color="#FF567F" :disabled="item?.status === 1 || isApproving"
                                @click="handleOpenRejected()">
                                Rejected
                              </v-btn>
                            </div>
                          </v-col>
                        </v-row>

                        <v-row v-if="item?.status === 2 || showRejectionCauseSection">
                          <v-col cols="12">
                            <h2>Rejection Cause</h2>
                          </v-col>

                          <v-col cols="12" v-if="item?.status !== 2">
                            <fieldset>
                              <legend>Reason</legend>
                              <v-select v-model="selectedReason" solo :items="slots5" append-icon="mdi-chevron-down"
                                label="Click to select" class="custom-select" hide-details />
                            </fieldset>
                          </v-col>

                          <v-col cols="12" v-if="item?.status === 2 || selectedReason === 'Other'">
                            <fieldset>
                              <legend>{{ item?.status === 2 ? "Reason" : "Write Your Reason" }}</legend>
                              <v-text-field :disabled="item?.status === 2" v-model="reason" single-line
                                :label="item?.status === 2 ? item?.reason : 'Write here'" solo hide-details
                                class="custom-select" />
                            </fieldset>
                          </v-col>

                          <v-col cols="6" v-if="item?.status !== 2">
                            <div class="button-wrapper">
                              <v-btn small tile elevation="0" block class="ma-0 text-capitalize btn-account py-4"
                                color="#FF567F" :loading="isRejecting" :disabled="isRejecting"
                                @click="handleWithdrawConfrimRejected(item)">
                                <v-progress-circular v-if="isRejecting" indeterminate size="16" width="2" color="white"
                                  class="mr-2" />
                                {{ isRejecting ? "Rejecting..." : "Confirm Reject" }}
                              </v-btn>
                            </div>
                          </v-col>

                          <v-col cols="6" v-if="item?.status !== 2">
                            <div class="button-wrapper">
                              <v-btn small tile elevation="0" block outlined
                                class="ma-0 text-capitalize btn-account py-4" @click="handleCloseRejected()">
                                Cancel
                              </v-btn>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </template>
                </v-dialog>
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { formatMySQLDate } from "@/_helpers/formateDate";
import { formatNumber } from "@/_helpers/formatNumber";
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";
import toast from "@/services/Notification";
import { PARTNERWITHDRAW__ACTIONS, TRANSACTIONS__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";
import QRCode from "qrcode";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


export default {
  data() {
    return {
      errors: { pay_slip: "" },
      pay_slip: null,
      previewUrl: null,
      fileRules: [(value) => !value || value.size < 2000000 || "File size should be less than 2MB"],

      search: "",
      searchTimeout: null,

      isApproving: false,
      isRejecting: false,

      selectedDates: [],
      selectedDatesText: null,

      options: { page: 1, itemsPerPage: 10 },
      date: null,

      slots: ["All", "Pending", "Approved", "Rejected"],
      updateslots: [
        { status: 0, statusText: "Pending" },
        { status: 1, statusText: "Approved" },
        { status: 2, statusText: "Rejected" },
      ],

      selectedStatus: null,
      modal: false,
      dialog: false,

      headers: [
        { text: "Date and Time", value: "created_at" },
        { text: "Name", value: "account_fullname" },
        { text: "Email", value: "account_email" },
        { text: "Acc no.", value: "trading_account_no" },
        { text: "Pay. Method", value: "payment_system" },
        { text: "Amount", value: "amount" },
        { text: "Remarks", value: "remarks" },
        { text: "Action By", value: "admin_name" },
        { text: "Status", value: "status" },
        { text: "Details", value: "details" },
      ],

      copiedStates: {},
      methodName: null,
      showRejectionCauseSection: false,
      selectedFile: null,
      reason: null,
      remarks: null,
      showButtons: true,
      selectedReason: null,
      detailsDialog: {},

      slots5: [
        "Deposit and withdrawal method must be same",
        "Not enough balance",
        "Can't transfer funds to third party accounts",
        "Any fraudulent activity we must suspend the principal account until investigation of compliance",
        "Other",
      ],

      // QR states
      walletQr: {},      // { [withdrawId]: dataURL }
      qrLoading: {},     // { [withdrawId]: true/false }
      walletCopied: {},  // { [withdrawId]: true/false }
    };
  },

  computed: {
    ...mapState("trxwithdrawal", [
      "withdrawal",
      "totalWithdrawalCount",
      "isLoading",
      "isUpdating",
      "paymentMethods",
      "totalWithdrawal",
      "pagination",
      "range",
    ]),

    ...mapState("admins", ["loggedAdmin"]),

    isItOpen() {
      return function (item) {
        return item?.status == 0;
      };
    },
  },

  methods: {
    formatMySQLDate,

    ...mapActions("trxwithdrawal", [
      TRANSACTIONS__ACTIONS.TRXWITHDRAWAL,
      TRANSACTIONS__ACTIONS.UPDATEDEPOSIT,
      TRANSACTIONS__ACTIONS.TRXWITHDRAWALEXCEL,
    ]),

    ...mapActions("partnerwithdraw", [PARTNERWITHDRAW__ACTIONS.UPDATEWITHDRAW]),

    verifyIcon(trx_type) {
      const lowerType = (trx_type || "").toLowerCase();
      if (lowerType.startsWith("d")) return "mdi mdi-tray-arrow-down mr-1";
      if (lowerType.startsWith("w")) return "mdi mdi-tray-arrow-up mr-1";
      return "mdi mdi-repeat mr-1";
    },

     async downloadCSVexcel() {
  await this[TRANSACTIONS__ACTIONS.TRXWITHDRAWALEXCEL]({
    limit: -1,
    search: this.search,
    method_name: this.methodName === "All" ? null : this.methodName,
    status:
      this.selectedStatus === "All" ? null :
      this.selectedStatus === "Pending" ? 0 :
      this.selectedStatus === "Approved" ? 1 :
      this.selectedStatus === "Rejected" ? 2 : null,
    duration: this.selectedDates?.length === 2 ? `${this.selectedDates[0]}to${this.selectedDates[1]}` : null
  });
},


    formattedAllNumber(num) {
      return formatNumber(num || 0);
    },

    downloadFile(fileUrl) {
      if (!fileUrl) return;
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = true;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    isImage(url) {
      return /\.(jpeg|jpg|png|gif|bmp|webp)$/i.test(url || "");
    },

    isPDF(url) {
      return /\.pdf$/i.test(url || "");
    },

    openInNewTab(url) {
      if (url) window.open(url, "_blank");
    },

    onFileChange(file) {
      if (file && file.size < 2000000) {
        this.pay_slip = file;
        const reader = new FileReader();
        reader.onload = (e) => (this.previewUrl = e.target.result);
        reader.readAsDataURL(file);
      } else {
        this.pay_slip = null;
        this.previewUrl = null;
        this.errors.pay_slip = "File size should be less than 2MB";
      }
    },

    //  Updated: receive full item so QR can generate; keep old behavior intact
    handleFile(item) {
      this.selectedFile = item?.payment_slip;
      this.pay_slip = null;
      this.previewUrl = null;

      if (this.shouldShowWalletQr(item)) {
        this.generateWalletQr(item);
      }
    },

    // =========================
    // QR Helpers
    // =========================
    extractWalletCandidate(raw) {
      if (!raw) return "";
      const cleaned = String(raw).trim();
      const parts = cleaned.split(/\s+/).filter(Boolean);
      const preferred = parts.find((p) => p.startsWith("0x")) || parts[0];
      return (preferred || "").trim();
    },

    isValidCryptoAddress(addr) {
      if (!addr) return false;
      const a = String(addr).trim();

      // ETH / EVM
      if (/^0x[a-fA-F0-9]{40}$/.test(a)) return true;

      // TRON (TRC20)
      if (/^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(a)) return true;

      // BTC legacy + segwit
      if (/^(bc1)[0-9a-z]{25,90}$/.test(a)) return true;
      if (/^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$/.test(a)) return true;

      // LTC
      if (/^(ltc1)[0-9a-z]{25,90}$/.test(a)) return true;
      if (/^[LM3][a-km-zA-HJ-NP-Z1-9]{26,33}$/.test(a)) return true;

      // XRP
      if (/^r[1-9A-HJ-NP-Za-km-z]{24,34}$/.test(a)) return true;

      // SOL
      if (/^[1-9A-HJ-NP-Za-km-z]{32,44}$/.test(a)) return true;

      return false;
    },

    shouldShowWalletQr(item) {
      const candidate = this.extractWalletCandidate(item?.wallet_address);
      return !!candidate && this.isValidCryptoAddress(candidate);
    },

    async generateWalletQr(item) {
      const id = item?.id;
      const candidate = this.extractWalletCandidate(item?.wallet_address);

      if (!id || !candidate || !this.isValidCryptoAddress(candidate)) return;
      if (this.walletQr[id]) return;

      this.$set(this.qrLoading, id, true);
      try {
        const dataUrl = await QRCode.toDataURL(candidate, {
          errorCorrectionLevel: "M",
          margin: 1,
          width: 220,
        });
        this.$set(this.walletQr, id, dataUrl);
      } catch (e) {
        console.error("QR generate failed:", e);
        this.$set(this.walletQr, id, null);
      } finally {
        this.$set(this.qrLoading, id, false);
      }
    },

    async copyToClipboard(text) {
      const value = (text || "").trim();
      if (!value) return false;

      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(value);
        return true;
      }

      const el = document.createElement("textarea");
      el.value = value;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(el);
      return ok;
    },

    async copyWalletAddress(item) {
      const id = item?.id;
      const candidate = this.extractWalletCandidate(item?.wallet_address) || item?.wallet_address;
      if (!candidate) return;

      try {
        await this.copyToClipboard(candidate);
        this.$set(this.walletCopied, id, true);
        setTimeout(() => this.$set(this.walletCopied, id, false), 1000);
      } catch (e) {
        console.error("Copy failed:", e);
      }
    },

    async handleWithdrawApprove(item) {
      try {
        this.isApproving = true;

        const formData = new FormData();
        formData.append("id", item?.id);
        formData.append("status", 1);
        formData.append("remarks", this.remarks || "N/A");

        if (this.pay_slip) formData.append("payment_slip", this.pay_slip);

        await this[PARTNERWITHDRAW__ACTIONS.UPDATEWITHDRAW](formData);
        await this[TRANSACTIONS__ACTIONS.TRXWITHDRAWAL]();

        this.pay_slip = null;
        this.previewUrl = null;
        this.remarks = "";
      } catch (error) {
        console.error("Error:", error);
      } finally {
        this.isApproving = false;
      }
    },

    handleOpenRejected() {
      this.showRejectionCauseSection = true;
      this.showButtons = false;
    },

    handleCloseRejected() {
      this.showRejectionCauseSection = false;
      this.showButtons = true;
      this.selectedReason = null;
    },

    async handleWithdrawConfrimRejected(item) {
      try {
        this.isRejecting = true;

        const formData = new FormData();
        formData.append("id", item?.id);
        formData.append("status", 2);
        formData.append("reason", this.reason || this.selectedReason || "N/A");

        if (this.pay_slip) formData.append("payment_slip", this.pay_slip);

        await this[PARTNERWITHDRAW__ACTIONS.UPDATEWITHDRAW](formData);

        this.showRejectionCauseSection = false;
        this.showButtons = true;
        this.selectedReason = null;
        this.reason = null;

        await this[TRANSACTIONS__ACTIONS.TRXWITHDRAWAL]();
      } catch (error) {
        console.error("Error:", error);
      } finally {
        this.isRejecting = false;
      }
    },

    handleClose(item) {
      this.$set(this.detailsDialog, item?.id, false);
      this.previewUrl = null;
      this.pay_slip = null;
    },

    allMethods() {
      return [{ id: "All", method_name: "All" }, ...this.paymentMethods];
    },

    async fetchData() {
      const parameter = {
        page: this.options.page || 1,
        limit: this.options.itemsPerPage || 10,
        search: this.search,
        method_name: this.methodName === "All" ? null : this.methodName,
        status:
          this.selectedStatus === "All"
            ? null
            : this.selectedStatus === "Pending"
              ? "0"
              : this.selectedStatus === "Approved"
                ? 1
                : this.selectedStatus === "Rejected"
                  ? 2
                  : null,
      };

      if (this.selectedDates?.length === 2) {
        parameter.duration = `${this.selectedDates[0]}to${this.selectedDates[1]}`;
      }

      await this[TRANSACTIONS__ACTIONS.TRXWITHDRAWAL](parameter);
    },

    async handleSearch() {
      await this.fetchData();
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => this.handleSearch(), 500);
    },

    handleOptionsChange() {
      this.fetchData();
    },

    methodFilter() {
      this.options.page = 1;
      this.fetchData();
    },

    onStatusChange() {
      this.page = 1;
      this.fetchData();
    },

    cancelSelection() {
      this.modal = false;
      this.selectedDates = [];
      this.selectedDatesText = null;
      this.fetchData();
    },

    confirmSelection() {
      if (this.selectedDates.length !== 2) {
        toast.error("Please select both start and end dates");
        return;
      }

      let [startDate, endDate] = this.selectedDates;
      if (new Date(startDate) > new Date(endDate)) {
        [startDate, endDate] = [endDate, startDate];
      }

      this.selectedDatesText = `${startDate} ~ ${endDate}`;
      this.modal = false;
      this.options.page = 1;
      this.fetchData();
    },

    onUpdateChange(item) {
      const parameter = {
        id: item?.id,
        status: item.status,
        remarks: this.remarks || "N/A",
      };
      this[PARTNERWITHDRAW__ACTIONS.UPDATEWITHDRAW](parameter);
    },

    getTextColor(item) {
      return item.status === 1 ? "text-approved" : item.status === 2 ? "text-decline" : "text-pending";
    },

    obfuscateAnyEmail(email) {
      return obfuscateEmail(email);
    },

    copyText(item) {
      navigator.clipboard.writeText(item?.account_email);
      this.$set(this.copiedStates, item.id, true);
      setTimeout(() => this.$set(this.copiedStates, item.id, false), 1000);
    },
  },

  watch: {
    range: {
      immediate: true,
      handler(r) {
        if (!r?.start || !r?.end) return;
        if (this.selectedDatesText) return;

        this.selectedDates = [r.start, r.end];
        this.selectedDatesText = `${r.start} ~ ${r.end}`;
      },
    },
  },

  async created() {
    await this.fetchData();
  },
};
</script>

<style>
.cursor-pointer {
  cursor: pointer;
}

.img-logo-bank {
  width: 200px;
  height: auto;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

/* QR styles */
.qr-fieldset {
  width: 320px;
  max-width: 100%;
  min-height: 255px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.qr-wrap {
  min-height: 190px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.qr-img {
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.85);
  padding: 10px;
  max-width: 100%;
}
</style>
